import { render } from "./ExtensionResultCard.vue?vue&type=template&id=791a3f1b&scoped=true"
import script from "./ExtensionResultCard.vue?vue&type=script&lang=js"
export * from "./ExtensionResultCard.vue?vue&type=script&lang=js"

import "./ExtensionResultCard.vue?vue&type=style&index=0&id=791a3f1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791a3f1b"]])

export default __exports__